export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'error',
      ErrCode: '4001',
      ErrInfo: 'アクセストークンの有効期限が切れました'
    }
  }
}